<template>
  <div>
    <ul class="list">
      <li class="item" v-for="(v, k) in dataList" :key="k">
        <div v-if="(v.payStatus==='payYet'|| v.payStatus=='yetPay')" class="item-status blue">支付成功</div>
        <div v-else-if="(v.insuranceStatus==='examine_fail')" class="item-status gray">核保未通过</div>
        <div v-else-if="(v.insuranceStatus==='theClose' && v.payStatus=='payClose')" class="item-status gray">已取消</div>
        <div v-else-if="(v.insuranceStatus==='cancelOrder' && v.payStatus=='refund')" class="item-status gray">已撤单</div>
        <div v-else-if="(v.payStatus==='partRefund')" class="item-status blue">{{v.payStatus | payStatus}}</div>
        <div v-else-if="(v.payStatus==='waitPay')" class="item-status green">核保通过</div>
        <div v-else class="item-status gray">{{ v.payStatus  | payStatus }}</div>
        <div class="item-name">{{ v.insuranceName }}</div>
        <table class="table">
          <tr>
            <td class="left-td">参保人：</td>
            <td>{{ v.insuredPersonName  }}</td>
          </tr>
          <tr>
            <td class="left-td">保险期间：</td>
            <td>{{ v.startDate | shortDate }}至{{ v.endDate | shortDate }}</td>
             <!-- <td>{{ v.insurancePeriod }}</td> -->
          </tr>
          <tr>
            <td class="left-td">支付状态：</td>
            <td>{{ v.payStatus | payStatus }}</td>
          </tr>
          <tr>
            <td class="left-td">保费：</td>
            <td>￥{{ v.insuredFeeAmount }}</td>
          </tr>
        </table>

        <!-- 巴陵e惠保2020 底部按钮 
        v-if="v.insuranceProductCode=='WX21010'"
        -->
        <div>
          <div v-if="v.payStatus=='waitPay'" class="btn-two">
            <div class="btn-div btn-look" @click="goDetail(v)">查看详情</div>
            <div class="btn-div" @click="goPay(v)">去支付</div>
          </div>
          <div v-else-if="(v.payStatus==='payYet'|| v.payStatus=='yetPay')" class="btn-two">
            <div class="btn-div btn-look" @click="goDetail(v)">查看详情</div>
            <!-- 
              <div class="btn-div" v-if="v.personalDeductionMethod" @click="cancelAppointment(v)">取消预约</div>
              <div class="btn-div" v-else @click="goAppointment(v)">个账预约</div>
            -->
          </div>
          <div v-else-if="(v.payStatus==='refund'||v.payStatus==='cancelOrder'||v.payStatus==='theClose'||v.payStatus=='abrogate'||v.insuranceStatus==='examine_fail') || (v.insuranceStatus==='theClose' && v.payStatus=='payClose')" class="btn-two">
            <div class="btn-div btn-look" @click="goDetail(v)">查看详情</div>
            <div class="btn-div" @click="handleReOrder(v)">重新获取保障</div>
          </div>
          <div class="btn-two" v-else>
            <div class="tr-flex" @click="goDetail(v)">查看详情</div>
          </div>
        </div>

        <!-- 巴陵e惠保2021 底部按钮 产品为：JCM016  查看详情 
          <div v-else-if="v.insuranceProductCode=='JCM016'">
            <div class="btn-two">
              <div class="tr-flex" @click="goDetail(v)">查看详情</div>
            </div>
          </div>
        -->
        <!-- 巴陵e惠保2021 底部按钮 历史订单只显示一个 查看详情 
          <div v-else>
            <div class="btn-two">
              <div class="tr-flex" @click="goDetail(v)">查看详情</div>
            </div>
          </div>
        -->
      </li>
    </ul>
  </div>
</template>

<script>
import { PolicyPayStatus, PolicyStatus } from '@/util/enum-data'
import { getPaymentUrl, cancelReservation } from '@/api/user'
export default {
  name: 'PolicyList',
  props: {
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {}
  },
  filters: {
    payStatus: function (val) {
      return PolicyPayStatus[val] || ''
    },
    policyStatus(val) {
      console.log('val--', val);
      return PolicyStatus[val] || ''
    },
    shortDate: function (val) {
      return val ? val.substr(0, 10) : ''
    },
    insuredFilter(val) {
      const arr = val.userInsureEntities.reduce((a, b) => {
        const name = b.personnelType === 'insured' ? [b.userName] : []
        return [].concat(a, name)
      }, [])
      return arr.join(', ')
    }
  },
  methods: {
    // 重新获取保障 
    handleReOrder(v) {
      // https://test.yuanxinbaoxian.com/wuxi_mobile/index.html?fromSourceCode=111111&baosicode=WX21010#/area-insu-buy-detail
      let jhb = `?fromSourceCode=${v.fromSourceCode}`
      let baosicode = `&baosicode=${process.env.VUE_APP_BAOSICODE}`
      const hostUrl = location.origin + location.pathname
      let link = ''
      if (hostUrl.indexOf('index.html') > 0) {
        console.log('000000');
        link = hostUrl + jhb + baosicode + '#/area-insu-buy-detail'
      } else {
        link = hostUrl + 'index.html' + jhb + baosicode + '#/area-insu-buy-detail'
      }
      window.location.href = link
    },
    // 快捷参保2021版
    async onerenewal(v) {
      this.$router.push({
        path: '/area-insu-buy-detail', query: {
          id: v.insuranceId
        }
      })
    },
    // 查看详情
    goDetail(v) {
      this.$router.push({ path: `/policy-detail/${v.insuranceId}` })
    },
    // 去支付
    async goPay(item) {
      const res = await getPaymentUrl({
        orderSn: item.userInsurePayOrderEntities[0].orderSn,
        openId: this.$store.state.userInfo.openId,
        payType: "weichatAcc",
        clientPayType: "JSAPI"
      })
      window.location.href = res.paymentUrl
    },
    // 跳转到个账预约页面
    goAppointment(item) {
      if (item.selfAccFlag == 0) {
        this.$toast('不满足申请条件，仅限有无锡市（含江阴、宜兴）职工基本医疗保险的参保人才能申请预约')
        return false
      }
      this.$router.push({
        name: 'Appointment',
        query: {
          insuranceId: item.userInsureId,
          selfAccFlag: item.selfAccFlag
        }
      })
    },
    // 取消个账预约
    async cancelAppointment(item) {
      // 取消预约条件：personalDeductionMethod不为空，且selfAccStatus==orderSelfAcc
      try {
        const res = await cancelReservation({
          insuranceId: item.userInsureId
        })
        console.log('res---', res);
        this.$emit('refreshList')
        this.$toast('预约已取消')
      } catch (e) {
        this.$notify({ color: '#F4111F', background: '#FFEC70', message: e.message })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.item {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 10px;
  border-radius: 5px;
  color: #4c4c4c;
  background-color: #fff;
  box-shadow: 0px 4px 16px 0px #eff5ff;
  margin-top: 10px;
  .item-status {
    position: absolute;
    top: 12px;
    right: 0;
    padding: 0 10px;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    font-size: 15px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: #fff;
    background-color: #02ba84;
  }
  .green {
    background-color: #02ba84;
  }
  .gray {
    background-color: #999999;
  }
  .blue {
    background-color: #1684ff;
  }

  .item-name {
    width: 72%;
    font-size: 18px;
    color: #333;
    height: 50px;
    line-height: 50px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }

  .item-info {
    margin-bottom: 3px;
    font-size: 15px;
    line-height: 1.5;
  }
  table {
    width: 100%;
    padding-bottom: 5px;
    border-top: 1px dashed #e8e8e8;
    border-bottom: 1px dashed #e8e8e8;
    tr {
      & > .left-td {
        width: 25% !important;
        min-width: 72px;
      }
    }

    td {
      font-size: 14px;
      line-height: 26px;
      color: #666;
    }
  }
  .btn-two {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 18px 0;
    .btn-div {
      flex: 1;
      margin: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 33px;
      border-radius: 16px;
      color: #fff;
      text-align: center;
      font-size: 16px;      
      background: linear-gradient(120deg, #FFAA60 0%, #FF4D14 100%, #FF4D14 100%);
    }
    .btn-look {
      border: 1px solid #f4111f;
      background: #fff;
      color: #f4111f;
    }
  }
  .tr-flex {
    width: 90%;
    margin: 10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FF4D14;
    // background: linear-gradient(to right, #db0003, #ff6c61);
    background-color: #fff;
    border: 1px solid #FF4D14;
    background-size: contain;
    background-position-x: center;
    border-radius: 16px;
    height: 33px;
    font-size: 15px;
  }
  .go-gift-friends {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    background: linear-gradient(to right, #f8c847 0%, #e88e53 100%);
    color: #fff;
    font-size: 15px;
    line-height: 15px;
    border-radius: 15px;
  }
  .onerenewal_flex {
    margin-top: 10px;
  }
}
</style>
